

/// <reference path="employee.module.ts" />
module Meevo.Plugins.Controls {

    export class TerminateController {

    static $inject = [
      "context",
      "$filter",
      "$mdDialog",
      "$translate","employee"];

    context: Plugins.Employee.EmployeeContext;

    selectedHomeLocation: Model.LocationListItem;
    terminatedDate: Date;
    hireDate: Date;
    doChangeHomeLocation: boolean;
    doDeleteFutureWorkTime: boolean;
    doDeleteFutureBlockTime: boolean;
    doInactivateUserAtAllLocations: boolean = false;
    message: string;


    constructor(context: Plugins.Employee.EmployeeContext,
      protected $filter: angular.IFilterService,
      protected  $mdDialog: angular.material.IDialogService,
      protected $translate: angular.translate.ITranslateService,
        employee: Model.Employee) {

      this.context = context;
      this.terminatedDate =moment(employee.terminatedDate).toDate();
      this.hireDate = moment(employee.hireDate).toDate();
      this.message = '';
    }

    apply = () => {
      var vm = this;

      this.message = '';
      if (Model.Guard.isNothing(this.terminatedDate)) {
        this.message = this.$translate.instant("LABEL_EMPLOYEE_TERMINATION_REQUIRED_DATE");
        return;
      } else if (moment(this.terminatedDate).isAfter(new Date())) {
        this.message = this.$translate.instant("MESSAGE_EMPLOYEE_TERMINATION_DATE_MUST_BE_IN_PAST");
        return;
      } else if (moment(this.terminatedDate).isBefore(this.hireDate)) {
        this.message = this.$translate.instant("MESSAGE_EMPLOYEE_TERMINATION_DATE_VALIDATION");
        return;
      }

      vm.context.terminate(this.terminatedDate,
        vm.doDeleteFutureWorkTime,
        vm.doDeleteFutureBlockTime,
        vm.selectedHomeLocation,
        vm.doInactivateUserAtAllLocations);

      this.$mdDialog.hide();
    };
    cancel = () => {
      this.$mdDialog.hide();
    };

  }

  angular.module("meevo.plugins.employee")
    .controller("meevo.plugins.employee.TerminateController", TerminateController);
}